import { TipoPagamento } from '../../models/TipoPagamento';
import { PaymentMethods } from '../../models/Usuario';

export type ProvedorPagamento = 'YUNO' | 'ADYEN';

export const getProvedorPagamento = (paymentMethods?: PaymentMethods): ProvedorPagamento =>
  paymentMethods?.usarYuno ? 'YUNO' : 'ADYEN';

export const getTipoPagamentoPix = (provedor: ProvedorPagamento) =>
  provedor === 'YUNO' ? TipoPagamento.YunoPix : TipoPagamento.Pix;

export const getTipoPagamentoCredito = (provedor: ProvedorPagamento) =>
  provedor === 'YUNO' ? TipoPagamento.YunoCredito : TipoPagamento.CartaoCredito;

export const getTipoPagamentoDebito = (provedor: ProvedorPagamento) =>
  provedor === 'YUNO' ? TipoPagamento.YunoDebito : TipoPagamento.CartaoDebito;

export const isPagamentoYuno = (tipoPagamento: TipoPagamento) =>
  tipoPagamento === TipoPagamento.YunoCredito ||
  tipoPagamento === TipoPagamento.YunoDebito ||
  tipoPagamento === TipoPagamento.YunoPix;
